var JV = JV || {};

JV.ContactImport = {
    fileCount: 0,
    numberOfFilesLeft: 0,
    validating: false,

    toggleTab: function(tab, showId) {
    $('#importTabs li').each(function() {
        $(this).removeClass('active');
    });
    $(tab).addClass('active');
    $("[TYPE='IMPORT_TAB']").each(function() {
        $(this).addClass('jv-hide');
    });
    $(showId).removeClass('jv-hide');

    //track how many times Import URLs tab is clicked
    if ('#jv-importUrlsTab' === showId) {
        if(typeof _gaq != 'undefined'){
        _gaq.push(['_trackEvent', 'CONTACT_IMPORT', 'import_url_tab_click']);
        }
    }
    },

    targetURLChange: function() {
    var urls = $('#jv-targetUrls').val();
    var urlCount = urls.split('\n').length;
    if (urlCount === 0) {
        $('#urlCount').html('000 URLs');
    } else {
        var text = urlCount + ' URL';
        if (urlCount > 1){
            text += 's';
        }
        $('#urlCount').html(text);
    }
    },

    guid: function() {
    function S4() {
        return (((1+Math.random())*0x10000)|0).toString(16).substring(1);
    }
    return (S4()+S4()+'-'+S4()+'-'+S4()+'-'+S4()+'-'+S4()+S4()+S4());
    },

    currentGuid: undefined,

    getFileExtension: function(fileName) {
    return fileName.split('.').pop();
    },

    toggleTemplate: function() {
    $('#template').fadeToggle();
    var ifHasMinusClass = $('#templatePlus').hasClass('jv-circleMinus')? true: false;
    if(ifHasMinusClass){
        $('#templatePlus').removeClass('jv-circleMinus');
    }else{
        $('#templatePlus').addClass('jv-circleMinus');
    }
    },

    updateFileCount: function() {
        var fileText = (this.fileCount === 0 || this.fileCount > 1)? i18n['JV_IMPORTCONTACTS__0_FILES'].format(this.fileCount) : i18n['JV_IMPORTCONTACTS_1_FILE'];
        $('#fileCount').html(fileText);
    },


    hideProgress: function() {
        $('.qq-upload-list').show();
        $('#progressbar').hide();
        $( '#progressbar' ).progressbar({
            value: 0
        });
        $('#validating').hide();
        $('#grayedImport').hide();
        $('#normalImport').show();
        this.updateFileCount();
        $('#uploadFilesButtonLabel').html(i18n['JV_IMPORTCONTACTS_UPLOAD_MORE_FILES']);
    },

    validateFile: function(fileName) {
    var that = this;
    var url = '/TalentNetwork/action/crm/contactaction?action=importValidate' + '&fileName=' + fileName + '&sessionGUID=' + this.currentGuid;
    $.ajax({
        dataType:'json',
        url: url,
        success: function(result) {
        if (result.result != 'success') {
            if (result.badFile) {
                var liText = '<span>' + i18n['JV_IMPORTCONTACTS_BAD_EXCEL_FILE_FORMAT_PLEASE_CHECK_TO_MAKE_SURE_TH'] + '</span>';
                var img = $('<img />', {
                    src: '/__assets__/images/error-icon.png'
                });
                img.addClass('warnIcon');
                var newLi = $('<li/>').append(img).append(liText);
                newLi.addClass('qq-upload-list-error');
                $('#warningArea').append(newLi);
            }
            if (result.missingCols && result.missingCols.length > 0) {
            var colText = 'column';
                if (result.missingCols.length > 1) {
                    colText = 'columns';
                }
                var uL = result.missingCols.join(',');
            var liText = '<span>' + JV.Person.Const['IMPORT_MISSING_COLS_MSG'].format(fileName, colText, uL, colText) + '</span>';
            var img = $('<img />', {
                src: '/__assets__/images/error-icon.png'
            });
            img.addClass('warnIcon');
            var newLi = $('<li/>').append(img).append(liText);
            newLi.addClass('qq-upload-list-error');
            $('#warningArea').append(newLi);
            }
            else if (result.unsupportedCols && result.unsupportedCols.length > 0) {
            var colText = 'column';
                if (result.unsupportedCols.length > 1) {
                    colText = 'columns';
                }
                var uL = result.unsupportedCols.join(',');
            var liText = '<span>' + JV.Person.Const['IMPORT_UNSUPPORTED_COLS_MSG'].format(fileName, colText, uL, colText) + '</span>';
            var img = $('<img/>', {
                src: '/__assets__/images/attention-icon.png'
            });
            img.addClass('warnIcon');
            var newLi = $('<li/>').append(img).append(liText);
            newLi.addClass('qq-upload-list-warning');
            $('#warningArea').append(newLi);
            }
        }
        that.validating=false;
        if (that.numberOfFilesLeft == 0) that.hideProgress();
        }
    });
    },

    isExcelFile: function(fileName) {
    var ext = this.getFileExtension(fileName);
    return ext == 'xls' || ext == 'xlsx';
    },

    createUploader: function(templ){
    this.fileCount = 0;
    this.currentGuid = this.guid();
    var that = this;
    var uploader = new qq.FileUploader({
        element: document.getElementById('ajax-upload'),
        action: '/TalentNetwork/action/common/fileupload?action=uploadTemp',
        sizeLimit:10485760,
        totalSize: 0,
        debug: false,
        currentSizes: {},
        params: {
            sessionGUID: that.currentGuid
        },
        template: templ ? templ : '<div class="qq-uploader"><span style="float:none;display:block;margin-bottom:5px" class="qq-upload-button jv-buttonWrapper jv-importClass"><ul><li class="jvdb-left custom_li"></li><li id="uploadFilesButton" class="jvdb-center custom_li">Upload files</li><li class="jvdb-right custom_li"></li></ul></span><ul class="qq-upload-list" style="border: 1px solid #CCCCCC;display:none"></ul><div class="qq-upload-drop-area"><span>' + i18n['JV_IMPORTCONTACTS_DROP_FILES_HERE_TO_UPLOAD'] + '</span></div></div>',
        fileTemplate: '<li>' +
                '<span class="qq-upload-file"></span>' +
                '<span class="qq-upload-spinner"></span>' +
                '<span class="qq-upload-size"></span>' +
                '<a class="qq-upload-cancel" href="#">' + i18n['JV_IMPORTCONTACTS_CANCEL'] + '</a>' +
                '<span class="qq-upload-failed-text">' + i18n['JV_IMPORTCONTACTS_FAILED'] + '</span>' +
        '</li>',
        onProgress: function(id, fileName, loaded, total){
            this.currentSizes[id] = loaded;
            var currProgress = 0;
            for (var key in this.currentSizes) {
                currProgress += this.currentSizes[key];
            }


            $('#progressbar').progressbar('value', Math.round(currProgress / this.totalSize * 100));
        },


        onSubmit: function(id, fileName){
        if (!navigator.userAgent.includes('MSIE')) {
            $('.qq-upload-list').hide();
            $('#progressbar').show();

        }
        var ext = that.getFileExtension(fileName);
        if (ext == 'exe') { //bug 9295
            that.hideProgress();
            return false;
        }

        this.totalSize += uploader._handler.getSize(id);
        that.numberOfFilesLeft++;
        },

        onComplete: function(id, fileName, responseJSON){
        that.fileCount++;
        that.numberOfFilesLeft--;
        if (that.isExcelFile(fileName)) {
            that.validating = true;
            that.validateFile(fileName);
        }
        if (that.numberOfFilesLeft == 0) {
            if (that.validating) {
            $('#validating').show();
            } else {
            that.hideProgress();
            }
        }       
        }
    });

    },
    getGUID : function() {
        return this.currentGuid;
    },
    uploadSubmit: function(){
    var noteText = $('#jv-noteMessage').val();
    var tags = [];
    $('.holder span').each(function(){
        tags.push($(this).text());
    });
    var tagText = tags.join(',');
    var importDuplicates = $('#importDuplicates').is(':checked');
    var urls = $('#jv-targetUrls').val().split('\n').join(',');

    var importUrl = '/TalentNetwork/action/crm/contactaction?action=import&sessionGUID=' + this.currentGuid + '&notes=' + noteText + '&tags=' + tagText + '&importDuplicates=' + importDuplicates + '&urls=' + encodeURIComponent(urls);
    $.ajax({
            url: importUrl,
            success: function(result) {
                JV.Modal.hide();
                JV.Util.showMessage(JV.Person.Const['IMPORT_START_SUCCESS']);
            }
    });
    return false;
    }


}

window.JV = window.JV || {};
window.JV.ContactImport = JV.ContactImport;